/****************************************************
 * Module Name:  changePasswordModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import Button from "@mui/material/Button";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import "bootstrap/dist/css/bootstrap.min.css";
import { TextField } from "@mui/material";
import { Box } from "@mui/system";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";

export default class ChangePasswordModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",

      oldPasswordType: "password",
      newPasswordType: "password",
      confirmPasswordType: "password",

      showError: false,
      errorMessage: "",

      oldPasswordValidationError: "",
      newPasswordValidationError: "",
      confirmPasswordValidationError: "",
    };
  }

  handleSave = () => {
    if (this.state.newPassword !== this.state.confirmPassword) {
      this.setState({
        showError: true,
        errorMessage: "New password and Confirm Password mismatched",
      });

      return;
    }

    let data = {
      id: this.props.sourceData.id,
      username: this.props.sourceData.username,
      oldpassword: this.state.oldPassword,
      newpassword: this.state.newPassword,
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) this.props.handleSave(data);
        else
          this.setState({
            showError: true,
            errorMessage: "Validation failed...",
          });
      } else this.props.handleSave(data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
      errorMessage: "",
    });
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              {this.state.errorMessage}
              <br /> Please enter correct data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Password change failed"
        />

        <Modal
          show={this.props.Show}
          onHide={this.props.handleClose}
          size="small"
          enforceFocus={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={Constants.COMPANY_LOGO}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;Change Password
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Box>
              <Box>
                <Box style={{ display: "flex", alignItems: "baseline" }}>
                  <p style={{ fontSize: "1.2rem" }}>Username :&nbsp;</p>
                  <p style={{ fontSize: "1.2rem", fontWeight: "600" }}>
                    {this.props.sourceData.username}
                  </p>
                </Box>
              </Box>

              <Box style={{ position: "relative", width: "100%" }}>
                <TextField
                  margin="normal"
                  fullWidth
                  name="password"
                  label="Current Password (required)"
                  type={this.state.oldPasswordType}
                  value={this.state.oldPassword}
                  onChange={(e) =>
                    this.setState({
                      oldPasswordValidationError: Utility.CheckIsPresent(
                        e.target.value
                      )
                        ? ""
                        : "Current Password Cannot be Empty",
                      oldPassword: e.target.value,
                    })
                  }
                  helperText={this.state.oldPasswordValidationError}
                  error={this.state.oldPasswordValidationError.length > 0}
                />
                <span>
                  <Button
                    style={{
                      background: "transparent",
                      cursor: "pointer",
                      position: "absolute",
                      right: "-10px",
                      marginTop: "25px",
                      border: "none",
                    }}
                    onMouseDown={(e) =>
                      this.setState({ oldPasswordType: "text" })
                    }
                    onMouseUp={(e) =>
                      this.setState({ oldPasswordType: "password" })
                    }
                    onMouseLeave={(e) =>
                      this.setState({ oldPasswordType: "password" })
                    }
                  >
                    {this.state.oldPasswordType === "password" ? (
                      <VisibilityOffIcon />
                    ) : (
                      <VisibilityIcon />
                    )}
                  </Button>
                </span>
              </Box>
              <Box style={{ position: "relative", width: "100%" }}>
                <TextField
                  margin="normal"
                  fullWidth
                  name="password"
                  label="New Password (required)"
                  type={this.state.newPasswordType}
                  value={this.state.newPassword}
                  onChange={(e) =>
                    this.setState({
                      newPasswordValidationError: Utility.CheckIsPresent(
                        e.target.value
                      )
                        ? ""
                        : "New Password Cannot be Empty",
                      newPassword: e.target.value,
                    })
                  }
                  helperText={this.state.newPasswordValidationError}
                  error={this.state.newPasswordValidationError.length > 0}
                />
                <span>
                  <Button
                    style={{
                      background: "transparent",
                      cursor: "pointer",
                      position: "absolute",
                      right: "-10px",
                      marginTop: "25px",
                      border: "none",
                    }}
                    onMouseDown={(e) =>
                      this.setState({ newPasswordType: "text" })
                    }
                    onMouseUp={(e) =>
                      this.setState({ newPasswordType: "password" })
                    }
                    onMouseLeave={(e) =>
                      this.setState({ newPasswordType: "password" })
                    }
                  >
                    {this.state.newPasswordType === "password" ? (
                      <VisibilityOffIcon />
                    ) : (
                      <VisibilityIcon />
                    )}
                  </Button>
                </span>
              </Box>
              <Box style={{ position: "relative", width: "100%" }}>
                <TextField
                  margin="normal"
                  fullWidth
                  name="password"
                  label="Confirm Password (required)"
                  type={this.state.confirmPasswordType}
                  value={this.state.confirmPassword}
                  onChange={(e) =>
                    this.setState({
                      confirmPasswordValidationError: Utility.CheckIsPresent(
                        e.target.value
                      )
                        ? ""
                        : "Confirm Password Cannot be Empty",
                      confirmPassword: e.target.value,
                    })
                  }
                  helperText={this.state.confirmPasswordValidationError}
                  error={this.state.confirmPasswordValidationError.length > 0}
                />
                <span>
                  <Button
                    style={{
                      background: "transparent",
                      cursor: "pointer",
                      position: "absolute",
                      right: "-10px",
                      marginTop: "25px",
                      border: "none",
                    }}
                    onMouseDown={(e) =>
                      this.setState({ confirmPasswordType: "text" })
                    }
                    onMouseUp={(e) =>
                      this.setState({ confirmPasswordType: "password" })
                    }
                    onMouseLeave={(e) =>
                      this.setState({ confirmPasswordType: "password" })
                    }
                  >
                    {this.state.confirmPasswordType === "password" ? (
                      <VisibilityOffIcon />
                    ) : (
                      <VisibilityIcon />
                    )}
                  </Button>
                </span>
              </Box>
            </Box>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="contained" onClick={() => this.handleSave()}>
              Save
            </Button>
            <Button
              variant="contained"
              color="error"
              sx={{ ml: 1 }}
              onClick={this.props.handleClose}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
